import { get, post } from "../GenericServices";

const TimesheetApprovalApi = {
  listEmployeeApproval: (queryString) => {
    return get(`timesheet-approval/employee?${queryString}`);
  },
  getTimesheetApprovalEmployee: (cid) => {
    return get(`timesheet-approval/employee/${cid}`);
  },
  submitTimesheetApproval: (cid, payload) => {
    return post(`timesheet-approval/employee/${cid}`, payload);
  },
  downloadTimesheetApprovalList: () => {
    return get(`timesheet-approval/resp-cdc-export`);
  },
  getDashboardData: () => {
    return get(`timesheet-approval/cost-centre-dashboard`);
  },
  exportPlannedVsTimesheetReport: (queryString) => {
    return get(`timesheet-approval/pm-timesheet-export?${queryString}`, {}, "blob");
  },
};

export default TimesheetApprovalApi;
